import * as React from 'react';
import { BaseRouteProps } from '../../../interfaces';
import { ScoreCardGroupCharacteristicDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { ScoreCardGroupCharacteristicForm } from './ScoreCardGroupCharacteristicForm';

export class ScoreCardGroupCharacteristicCreate extends React.Component<BaseRouteProps<{groupId: number}>> {
    private scoreCardGroupCharacteristicDataService = new ScoreCardGroupCharacteristicDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{groupId: number}>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public render() {
        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="title">
                            <NavLink to={`/scorecardgroup/${this.props.match.params.groupId}/characteristics`}>
                                <span className="glyphicon glyphicon-triangle-left" />
                            </NavLink>
                            &nbsp;
                            Create Score Card Group Characteristic
                        </div>
                    </div>
                </div>
  
                <div className="content-body">
                    <div className="content-container">
                        <ScoreCardGroupCharacteristicForm submit={(e: any) => this.save(e)} defaultValues={{}} />
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        values.scoreCardGroupID = this.props.match.params.groupId;
        this.scoreCardGroupCharacteristicDataService.create(values).then((success) => {
            this.props.history.push(`/scorecardgroup/${this.props.match.params.groupId}/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroupCharacteristic/ScoreCardGroupCharacteristicCreate.tsx